import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import _ from 'lodash';
import { Card, Image, Label, Button } from 'semantic-ui-react';

const styles = {
  thumb: { width: '100%', height: '180px', objectFit: 'cover' },
  noImage: {
    height: '180px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: '#ccc',
    background: '#f4f4f4',
    fontSize: '85%',
  },
  header: { fontSize: '0.9em' },
  description: { marginTop: '6px' },
  caption: {
    marginTop: '6px', fontSize: '85%', whiteSpace: 'pre-wrap', color: '#555',
  },
};

const StoryCard = ({
  story, added, adding, onAdd,
}) => (
  <Card>
    { story.thumbnailUrl
      ? (
        <a href={story.linkUrl || story.thumbnailUrl} target="_blank" rel="noopener noreferrer">
          <Image src={story.thumbnailUrl} style={styles.thumb} />
        </a>
      )
      : <div style={styles.noImage}>no image</div>
    }
    <Card.Content>
      <Card.Header style={styles.header}>@{story.handle || 'unknown'}</Card.Header>
      <Card.Meta>{ story.takenAt ? moment(story.takenAt).format('lll') : '' }</Card.Meta>
      <Card.Description style={styles.description}>
        { story.matched
          ? <Label size="tiny" color="green">Matched</Label>
          : <Label size="tiny" basic color="orange">Unmatched</Label>
        }
        { story.reviewed && <Label size="tiny" color="blue">Reviewed</Label> }
        { story.status && story.platform === 'TIKTOK' &&
          <Label size="tiny" basic>{story.status}</Label>
        }
        { story.caption && <div style={styles.caption}>{story.caption}</div> }
      </Card.Description>
    </Card.Content>
    { !_.isEmpty(story.hashtags) &&
      <Card.Content extra>
        { story.hashtags.map(tag => <Label key={tag} size="mini" basic>{tag}</Label>) }
      </Card.Content>
    }
    <Card.Content extra>
      { added
        ? <Button size="tiny" basic color="green" fluid disabled icon="check" content="Added" />
        : (
          <Button
            size="tiny"
            primary
            fluid
            loading={adding}
            disabled={adding}
            onClick={onAdd}
            content="Add to collaboration"
          />
        )
      }
    </Card.Content>
  </Card>
);

StoryCard.propTypes = {
  story: PropTypes.object.isRequired,
  added: PropTypes.bool.isRequired,
  adding: PropTypes.bool.isRequired,
  onAdd: PropTypes.func.isRequired,
};

export default StoryCard;



/** WEBPACK FOOTER **
 ** ./src/components/all-stories-modal/StoryCard.js
 **/